import { Mutation, Action, VuexModule, getModule, Module } from 'vuex-module-decorators';
import store from '@/store';
import { UketsukeConstants } from '@/Uketsuke/fixed/UketsukeConstants';
// import { ChangeType } from '../../fixed/ApplicationChangeType';
// import { ProcessType } from '../../fixed/ApplicationProcessType';


@Module({ dynamic: true, store, name: 'applicationForm', namespaced: true })
class ApplicationForm extends VuexModule {
    // state
    /**
     * @state
     * 遷移元（業者明細画面に遷移する前の元画面を保存）
     */
    transitionSourceScreen: string = '';
    /**
     * @state
     * 申請種別（業者種別TraderType）
     */
    appFormType: string = '';

    /**
     * @state
     * 自治体情報
     */
    municipalInfo: string = '';

    /**
     * @state
     * 業者番号キー
     */
    traderId: string = '';

    /**
     * @state
     * 前回業者番号キー（継続申請時）
     */
    beforeTraderId: string = '';

    /**
     * @state
     * 変更区分
     */
    changeType: string = '';

    /**
     * @state
     * 要求処理
     */
    processType: string = '';

    /**
     * @state
     * 申請年度
     */
    nendo: string = '';

    /**
     * @state
     * 添付資料受付確認フラグ&不受理理由
     */
    checkApplicationAccept: string[] = new Array(2);

    /**
     * @state
     * 受付番号
     */
    acceptNo: string = '';

    /**
     * @state
     * 提出済みフラグ
     */
    isSubmitEnd: boolean = false;

    /**
     * @state
     * 再検索フラグ
     * ='1'の時再検索を行う
     */
    reSearchFlag = '0';

    /**
     * @state
     * フォームデータ
     * 検索条件を格納する
     */
    formData: any = [];

    /**
     * @Getter
     * 遷移元を返す
     * @returns string
     */
    get GET_TRANSITION_SOURCE_SCREEN() {
        return this.transitionSourceScreen;
    }

    /**
     * @Getter
     * 申請種別（業者種別TraderType）を返す
     * @returns string
     */
    get GET_APP_TYPE() {
        return this.appFormType;
    }

    /**
     * @Getter
     * 自治体情報を返す
     * @returns string
     */
    get GET_MUNICIPAL() {
        return this.municipalInfo;
    }

    /**
     * @Getter
     * 業者番号キーを返す
     * @returns string
     */
    get GET_TRADER_ID() {
        return this.traderId;
    }

    /**
     * @Getter
     * 前回業者番号キーを返す
     * @returns string
     */
    get GET_BEFORE_TRADER_ID() {
        return this.beforeTraderId;
    }

    /**
     * @Getter
     * 変更区分を返す
     * @returns string
     */
    get GET_CHANGE_TYPE() {
        return this.changeType;
    }

    /**
     * @Getter
     * 要求処理を返す
     * @returns string
     */
    get GET_PROCESS_TYPE() {
        return this.processType;
    }

    /**
     * @Getter
     * 申請年度を返す
     * @returns string
     */
    get GET_NENDO() {
        return this.nendo;
    }

    /**
     * @Getter
     * 受付番号を返す
     * @returns string
     */
    get GET_ACCEPT_NO() {
        return this.acceptNo;
    }

    /**
     * @getter
     * 提出済みフラグを返す
     */
    get IS_SUBMIT_END() {
        return this.isSubmitEnd;
    }

    /**
     * @Getter
     * 業者番号キーが設定されていればtrueを返す
     * @returns boolean
     */
    get IS_SET_TRADER_ID() {
        if (!this.traderId || this.traderId === '') {
            return false;
        }
        return true;
    }

    /**
     * @Getter
     * 前回業者番号キーが設定されていればtrueを返す
     * @returns boolean
     */
    get IS_SET_BEFORE_TRADER_ID() {
        if (!this.beforeTraderId || this.beforeTraderId === '') {
            return false;
        }
        return true;
    }

    /**
     * @Getter
     * 変更区分が設定されていればtrueを返す
     * @returns boolean
     */
    get IS_SET_CHANGE_TYPE() {
        if (!this.changeType || this.changeType === '') {
            return false;
        }
        return true;
    }

    /**
     * @Getter
     * stateの申請種別（業者種別TraderType）が工事であればtrueを返す
     * @returns boolean
     */
    get CHECK_TYPE_CONST() {
        if (this.appFormType === UketsukeConstants.APP_FORM_CONST) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * @Getter
     * stateの申請種別（業者種別TraderType）が委託であればtrueを返す
     * @returns boolean
     */
    get CHECK_TYPE_CONSUL() {
        if (this.appFormType === UketsukeConstants.APP_FORM_CONSUL) {
            return true;
        } else {
            return false;
        }
    }
    //20210910 [01_調達区分_維持管理業務追加] ueda ADD Start
    /**
     * @Getter
     * stateの申請種別（業者種別TraderType）が維持管理であればtrueを返す
     * @returns boolean
     */
     get CHECK_TYPE_MAINTENANCE() {
        if (this.appFormType === UketsukeConstants.APP_FORM_MAINTENANCE) {
            return true;
        } else {
            return false;
        }
    }
    //20210910 [01_調達区分_維持管理業務追加] ueda ADD End
    /**
     * @Getter
     * stateの申請種別（業者種別TraderType）が物品であればtrueを返す
     * @returns boolean
     */
    get CHECK_TYPE_GOODS() {
        if (this.appFormType === UketsukeConstants.APP_FORM_GOODS) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * @getter
     * reSearchFlagの取得
     * 1ならtrueを返す
     */
    get CHECK_RE_SEARCH() {
        if (this.reSearchFlag === '1') {
            return true;
        }
        return false;
    }

    /**
     * @Getter
     * formDataの取得
     */
    get GET_FORM_DATA() {
        return this.formData;
    }

    /**
     * @Action
     * 申請種別（業者種別TraderType）を設定する
     */
    @Action({})
    public setType(param: string) {
        switch (param) {
            case UketsukeConstants.APP_FORM_CONST:
                this.SET_TYEP_CONST();
                break;
            case UketsukeConstants.APP_FORM_CONSUL:
                this.SET_TYEP_CONSUL();
                break;
            //20210910 [01_調達区分_維持管理業務追加] ueda ADD Start
            case UketsukeConstants.APP_FORM_MAINTENANCE:
                this.SET_TYEP_MAINTENANCE();
                break;
            //20210910 [01_調達区分_維持管理業務追加] ueda ADD End
            case UketsukeConstants.APP_FORM_GOODS:
                this.SET_TYEP_GOODS();
                break;
            default:
                break;
        }
    }

    /**
     * @Action
     * 変更区分を設定する
     */
    @Action({})
    public setChangeType(param: string) {
        this.SET_CHANGE_TYPE(param);
    }

    /**
     * @Action
     * 要求処理を設定する
     */
    @Action({})
    public setProcessType(param: string) {
        this.SET_PROCESS_TYPE(param);
    }

    /**
     * @Action
     * 要求処理を設定する
     */
    @Action({})
    public setNendo(param: string) {
        this.SET_NENDO(param);
    }

    /**
     * @Action
     * 申請種別（業者種別TraderType）を工事に設定する
     */
    @Action({})
    public setTypeConst() {
        this.SET_TYEP_CONST();
    }

    /**
     * @Action
     * 申請種別（業者種別TraderType）を委託に設定する
     */
    @Action({})
    public setTypeConsul() {
        this.SET_TYEP_CONSUL();
    }

    //20210910 [01_調達区分_維持管理業務追加] ueda ADD Start
    /**
     * @Action
     * 申請種別（業者種別TraderType）を維持管理に設定する
     */
     @Action({})
     public setTypeMaintenance() {
         this.SET_TYEP_MAINTENANCE();
     }
    //20210910 [01_調達区分_維持管理業務追加] ueda ADD End
    /**
     * @Action
     * 申請種別（業者種別TraderType）を物品に設定する
     */
    @Action({})
    public setTypeGoods() {
        this.SET_TYEP_GOODS();
    }

    /**
     * @Action
     * 自治体情報を格納する
     */
    @Action({})
    public setMunicipal(param: string) {
        this.SET_MUNICIPAL(param);
    }

    /**
     * @Action
     * 業者番号キーを格納する
     */
    @Action({})
    public setTraderId(param: string) {
        this.SET_TRADER_ID(param);
    }

    /**
     * @Action
     * 前回業者番号キーを格納する
     */
    @Action({})
    public setBeforeTraderId(param: string) {
        this.SET_BEFORE_TRADER_ID(param);
    }

    /**
     * @Action
     * 受付番号を格納する
     */
    @Action({})
    public setAcceptNo(param: string) {
        this.SET_ACCEPT_NO(param);
    }

    /**
     * @Action
     * 提出済みフラグを格納する
     */
    @Action({})
    public setIsSubmitEnd(param: boolean) {
        this.SET_IS_SUBMIT_END(param);
    }

    /**
     * @Action
     * フォームデータの保管
     * @param data
     */
    @Action({})
    public setFormData(data: any) {
        this.SET_FORM_DATA(data);
    }

    /**
     * @Action
     * フォームデータのリセット
     * @param data
     */
    @Action({})
    public resetFormData() {
        this.RESET_FORM_DATA();
    }

    @Action({})
    public moduleReset() {
        this.MODULE_RESET();
        this.MODULE_RESET_DETAIL();
    }

    @Action({})
    public moduleResetDetail() {
        this.MODULE_RESET_DETAIL();
    }

    /**
     * @Action
     * 遷移元を設定する
     */
    @Action({})
    public setTransitionSourceScreen(param: string) {
        this.SET_TRANSITION_SOURCE_SCREEN(param);
    }

    @Mutation
    private SET_TRANSITION_SOURCE_SCREEN(param: string) {
        this.transitionSourceScreen = param;
    }

    @Mutation
    private SET_TYEP_CONST() {
        this.appFormType = UketsukeConstants.APP_FORM_CONST;
    }

    @Mutation
    private SET_TYEP_CONSUL() {
        this.appFormType = UketsukeConstants.APP_FORM_CONSUL;
    }
    //20210910 [01_調達区分_維持管理業務追加] ueda ADD Start
    @Mutation
    private SET_TYEP_MAINTENANCE() {
        this.appFormType = UketsukeConstants.APP_FORM_MAINTENANCE;
    }
    //20210910 [01_調達区分_維持管理業務追加] ueda ADD End
    @Mutation
    private SET_TYEP_GOODS() {
        this.appFormType = UketsukeConstants.APP_FORM_GOODS;
    }

    @Mutation
    private SET_MUNICIPAL(param: string) {
        this.municipalInfo = param;
    }

    @Mutation
    private SET_TRADER_ID(param: string) {
        this.traderId = param;
    }

    @Mutation
    private SET_BEFORE_TRADER_ID(param: string) {
        this.beforeTraderId = param;
    }

    @Mutation
    private SET_CHANGE_TYPE(param: string) {
        this.changeType = param;
    }

    @Mutation
    private SET_PROCESS_TYPE(param: string) {
        this.processType = param;
    }

    @Mutation
    private SET_NENDO(param: string) {
        this.nendo = param;
    }

    @Mutation
    private SET_ACCEPT_NO(param: string) {
        this.acceptNo = param;
    }

    @Mutation
    private SET_IS_SUBMIT_END(param: boolean) {
        this.isSubmitEnd = param;
    }

    @Mutation
    private MODULE_RESET() {
        this.appFormType = '';
        this.checkApplicationAccept = new Array(2);
    }

    @Mutation
    private MODULE_RESET_DETAIL() {
        this.municipalInfo = '';
        this.traderId = '';
        this.beforeTraderId = '';
        this.processType = '';
        this.changeType = '';
        this.acceptNo = '';
        this.isSubmitEnd = false;
    }

    @Mutation
    private SET_FORM_DATA(data: any) {
        this.reSearchFlag = '1';
        this.formData = data;
    }

    @Mutation
    private RESET_FORM_DATA() {
        this.reSearchFlag = '0';
        this.formData = [];
    }
}

export const applicationFormModule = getModule(ApplicationForm);
